import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Alert,
  Container,
} from '@mui/material';
import { markAsRead } from '../../reducers/notificationReducer';
import { useDispatch } from 'react-redux';
const NotificationDetail = () => {
  const dispatch = useDispatch();
  const { state } = useLocation(); // This is where params are passed via navigate
  const { notificationId, notifications } = state || {};
  // console.log(notificationId, notifications);
  
  useEffect(() => {
  dispatch(markAsRead(notificationId));
}, [dispatch, notificationId]);
  
  if (!notifications) {
    return (
      <Container maxWidth="sm">
        <Box mt={4}>
          <Alert severity="error">Notification not found.</Alert>
        </Box>
      </Container> 
    );
  }

  return (
    <Container maxWidth="sm">
      <Card sx={{ mt: 4, padding: 2 }}>
        <CardContent>
          <Typography variant="h5" gutterBottom>
            {notifications[0]?.Title} 
          </Typography>
          <Typography variant="body1" paragraph>
  { notifications[0]?.Comments ?? "No message available"}
</Typography>

          
          <Typography variant="caption" color="text.secondary">
  {new Date(  notifications[0]?.created_at).toLocaleString()}
</Typography>

        </CardContent>
      </Card>
    </Container>
  );
};

export default NotificationDetail;
